import { useEffect } from 'react'

import Link from 'next/link'

import { useBlogHook } from '@/hooks/useBlogHook'

import BlogCard from './BlogCard'

const BlogList = () => {
  const { getPosts, posts, setPosts } = useBlogHook()

  useEffect(() => {
    getPosts(
      {
        limit: 4,
        highlight: true,
        currentPage: 1
      },
      {
        onSuccess: res => {
          setPosts(res.data.data)
        }
      }
    )
  }, [])

  return (
    <>
      {posts && posts.length > 0 ? (
        <section className='blogList pb-[40px]'>
          <div className='head-sec relative mb-2 text-left'>
            <h3 className={`text-2xl font-bold leading-normal`}>Tin tức & khuyến mãi</h3>

            <Link
              href='/post'
              className='btnMore absolute right-0 top-[50%] flex h-[36px] translate-y-[-50%] items-center justify-center gap-1 px-2 text-base font-semibold text-primary-base'
            >
              <span className=''>Xem tất cả</span>
              <img src='/assets/icons/arrow/right-arrow-red.svg' alt='Xem tất cả' />
            </Link>
          </div>
          <div className={`listBlog grid grid-cols-4 gap-2`}>
            {posts && posts?.map((e, index) => <BlogCard key={index} post={e} />)}
          </div>
        </section>
      ) : (
        ''
      )}
    </>
  )
}

export default BlogList
